import { normalizeCandidateCountry, resolveCountryCode } from "./rawCandidates.js";

// Algolia records mix flattened profile fields with a nested location object.
export function readSearchField(record, path) {
  return record?.[path] ?? path.split(".").reduce((value, part) => value?.[part], record);
}

const text = (value) => typeof value === "string" ? value.trim() : "";

export function normalizeProfileLocation(record = {}) {
  const raw = [
    readSearchField(record, "location.location"),
    readSearchField(record, "location.default"),
    readSearchField(record, "location.rawLocation"),
    readSearchField(record, "profile.location"),
    record.location,
  ].map(text).find(Boolean) || "";
  const parts = raw.split(",").map((part) => part.trim()).filter(Boolean);
  const parsedCountry = resolveCountryCode(parts.at(-1) || "");
  const city = text(readSearchField(record, "location.city")) ||
    (parts.length >= 3 && parsedCountry ? parts[0] : "");
  const countryCode = resolveCountryCode(
    readSearchField(record, "location.countryCode") ||
    readSearchField(record, "location.country_code") ||
    readSearchField(record, "location.country") ||
    readSearchField(record, "profile.country_code") || parsedCountry,
  );
  const country = normalizeCandidateCountry(
    text(readSearchField(record, "location.country")), countryCode,
  );
  return { city, country, countryCode, location: raw || [city, country].filter(Boolean).join(", ") };
}

// Only fill an absent structured city. Keep a supplied city, coordinates, and
// legacy text intact; never replace a string-valued location with an object.
export function missingStructuredLocationFields(record = {}) {
  if (record.location && (typeof record.location !== "object" || Array.isArray(record.location))) return {};
  const location = normalizeProfileLocation(record);
  const textCountry = resolveCountryCode(location.location.split(",").at(-1)?.trim());
  if (textCountry && location.countryCode && textCountry !== location.countryCode) return {};
  return Object.fromEntries([
    ["location.city", location.city],
  ].filter(([field, value]) => value && !String(readSearchField(record, field) || "").trim()));
}
